import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import { Input, FormControl } from '@material-ui/core';

import FieldError from '../components/FieldError';

const Container = styled.div`
  padding: ${rhythm(1.5)} 0;
`;

const CopyTxt = styled.div`
  font-size: 12px;
`;

const Heading = styled.h1`
  font-size: 1rem;
`;

const InnerContainer = styled.div`
  padding-bottom: ${rhythm(2.5)};
`;
const AddUrlText = styled.span`
  color: rgba(255, 0, 0, 0.42);
`;
const InputUrl = styled(Input)`
  &&&:before {
    border-bottom: 1px solid rgba(255, 0, 0, 0.42);
  }
  &&&:after {
    border-bottom: 2px solid rgba(255, 0, 0, 0.42);
  }
  &&&:hover:before {
    border-bottom: 2px solid rgba(255, 0, 0) !important;
  }
`;

const NoteAndUrl = ({ onUrlAndNoteChange, note, noteError, urlError, url }) => (
  <Container>
    <Heading>
      <div>Respond to specifier</div>
      {noteError && <FieldError>*{noteError}</FieldError>}
    </Heading>
    <InnerContainer>
      <FormControl fullWidth>
        <Input
          multiline
          rowsMax={4}
          scroll="body"
          onChange={onUrlAndNoteChange('slipNote')}
          value={note}
          fullWidth
          placeholder="Note"
        />
      </FormControl>
    </InnerContainer>

    <Heading>
      <div>
        URL<AddUrlText>*</AddUrlText>
        <CopyTxt>(Copy and paste full address from browser)</CopyTxt>
      </div>
      {urlError && <FieldError>{urlError}</FieldError>}
    </Heading>
    <InnerContainer>
      <FormControl fullWidth>
        <InputUrl
          onChange={onUrlAndNoteChange('url')}
          value={url}
          fullWidth
          placeholder="http://yourcompany.com/luminaire"
        />
      </FormControl>
      {/* <InfoWrapper>
        <div>Copy and paste full address from browser.</div>
        <div>Example format: http://luminairebroker.arup.com</div>
      </InfoWrapper> */}
    </InnerContainer>
  </Container>
);

export default NoteAndUrl;
